import axiosInstance from '../configs/axios/interceptors';

const AttachmentServices = {

    getAttachments: async (filters) => {
        const response = await axiosInstance.get('SupplierAttachments/GetSupplierAttachmentsList', { params: filters });
        return response.data;
    },

    deleteAttachment: async (fileId) => {
        const params = { id: fileId };
        const response = await axiosInstance.delete('SupplierAttachments/RemoveSupplierAttachment', { params: params });
        return response.data;
    },

    addAttachments: async (payload) => {
        const response = await axiosInstance.post('SupplierAttachments/UploadSupplierAttachment', payload, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        return response.data;
    },

    getAttachmentsFiles: async (filters) => {
        const params = {}
        const bodyData = {
            idList: filters.idList,
            userID: filters.userID
        };

        const response = await axiosInstance.post('SupplierAttachments/GetSupplierAttachmentsExportList',
            bodyData,
            {
                params: params
            });
        return response.data;
    },

};

export default AttachmentServices;
